export const assetPathBuilder = (iconName: string, filled = false) => {
    const formattedIconName = iconNameMapper(iconName);
    const formattedAssetsPath = formatPath(assetsPath, false);
    const formattedBuildHash = formatPath(buildHash);
    const filledResources = filled ? 'Filled' : '';

    return `${formattedAssetsPath}/iconsSprite${filledResources}${formattedBuildHash}.svg#sprite-${formattedIconName}`;
};

const formatPath = (path?: string, withDot = true) => (path ? `${withDot ? '.' : ''}${path}` : '');

export const iconNameMapper = (iconName: string) => {
    switch (iconName) {
        case 'å':
            return 'aring';
        case 'æ':
            return 'ae';
        case 'ø':
            return 'oslash';
        default:
            return iconName;
    }
};
